import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Avatar } from '@conexasaude/hero'
import { IConsultationDetailsResponseGroup } from '../../types'

type ResumeDoctorGroupProps = Pick<
  IConsultationDetailsResponseGroup,
  'professionalSpecialty' | 'professionalName'
>
const ResumeDoctorGroup: FunctionComponent<ResumeDoctorGroupProps> = ({
  professionalSpecialty,
  professionalName,
}) => {
  const { doctorSection, avatar } = useStyles()

  return (
    <div css={doctorSection} className="details-section">
      <span>Quem irá te atender</span>
      <section>
        <Avatar src={null} size="xl" styles={{ avatar: avatar }} />
        <div className="consultation-with">
          <span>{`Consulta com'${professionalName}`}</span>
          <br />
          <span>{professionalSpecialty}</span>
        </div>
      </section>
    </div>
  )
}

export default ResumeDoctorGroup
